import React, {useEffect} from 'react';
import img_radar from '../images/radar.svg';
import Player from 'react-player/file';
import produce from 'immer';
import _find from 'lodash/find';
import _uniq from 'lodash/uniq';
import {CopyToClipboard as Copy} from 'react-copy-to-clipboard';
import '../styles/video-radar.css';

const urlRegex = /[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/gi;

function Home() {

  const [linksBulk, setLinksBulk] = React.useState('');
  const [started, setStarted] = React.useState(false);
  const [status, setStatus] = React.useState([]);
  const [files, setFiles] = React.useState([]);
  const [players, setPlayers] = React.useState(10);
  const [dropOpen, setDropOpen] = React.useState(false);

  const fileInputRef = React.useRef();

  useEffect(() => {
    window.scrollTo(0, 0);

  }, [started]);

  const start = () => {

    let filesPaths = [];
    let newStatus = [];

    files.forEach(v => {
      filesPaths.push(v.path);
    });

    const links = _uniq(
        linksBulk.split(/\r?\n/g).filter(link => link.match(urlRegex)).concat(filesPaths),
    );

    links.forEach((v, i) => {
      newStatus.push({
        id: i,
        loaded: 0,
        played: 0,
        alreadyPlayed: i < players,
        playerId: i < players ? i : -1,
        stat: 0,
        message: i < players ? 'Running' : 'Waiting',
        url: v,
        name: _find(files, {path: v}) ? _find(files, {path: v}).name : v,
        elapsed: 0,
      });
    });

    setStatus(newStatus);
    setStarted(true);

  };

  const handleProgress = (data, i) => {

    const coIndex = _find(status, {playerId: i}).id;

    setStatus(produce(status, draft => {

      draft[coIndex].played = (data.played * 100).toFixed(0);
      draft[coIndex].loaded = (data.loaded * 100).toFixed(0);
      draft[coIndex].elapsed = (data.playedSeconds / 15).toFixed(0);

    }));
  };

  const handleEnd = (i) => {

    const nextCo = _find(status, {alreadyPlayed: false});
    const currentCoIndex = _find(status, {playerId: i}).id;

    if (nextCo !== undefined) {
      setStatus(produce(status, draft => {

        draft[currentCoIndex].message = <span className='text-success'>Ok</span>;
        draft[currentCoIndex].stat = 1;
        draft[currentCoIndex].played = 100;
        draft[currentCoIndex].playerId = -1;

        draft[nextCo.id].playerId = i;
        draft[nextCo.id].alreadyPlayed = true;
        draft[nextCo.id].message = 'Running';

      }));

    } else {
      setStatus(produce(status, draft => {

        draft[currentCoIndex].message = <span className='text-success'>Ok</span>;
        draft[currentCoIndex].stat = 1;
        draft[currentCoIndex].played = 100;

      }));
    }

  };

  const handleError = (error, i) => {

    const nextCo = _find(status, {alreadyPlayed: false});
    const currentCoIndex = _find(status, {playerId: i}).id;

    if (nextCo !== undefined) {
      setStatus(produce(status, draft => {

        draft[currentCoIndex].message = <span className='text-danger'>
          Error at <strong>{format(error.target.currentTime)}</strong>
        </span>;

        draft[currentCoIndex].stat = -1;
        draft[currentCoIndex].playerId = -1;

        draft[nextCo.id].playerId = i;
        draft[nextCo.id].alreadyPlayed = true;
        draft[nextCo.id].message = 'Running';

      }));

    } else {
      setStatus(produce(status, draft => {

        draft[currentCoIndex].message = <span className='text-danger'>
          Error at <strong>{format(error.target.currentTime)}</strong>
        </span>;
        draft[currentCoIndex].stat = -1;

      }));
    }

  };

  const handleFiles = (v) => {
    if (v.target.files && v.target.files.length > 0) {

      let paths = [];
      for (const file of v.target.files) {
        paths.push({path: URL.createObjectURL(file), name: file.name});
      }

      setFiles(paths);
    }
  };

  const reset = () => {
    setLinksBulk('');
    setStatus([]);
    setStarted(false);
    fileInputRef.current.value = null;
    setFiles([]);
  };

  const playersC = status.length < players ?
      new Array(status.length).fill(0)
      :
      new Array(players).fill(0);

  return (
      <div style={{maxWidth: 800}} className='d-flex flex-column p-2 align-items-center mx-auto'>

        <div className='d-flex mt-2 align-items-center justify-content-center text-center'>
          <img className='mb-2 me-2' src={img_radar} alt='' width={42} height={42}/>
          <h1>Video Checker</h1>
        </div>

        <div className='d-none'>
          {started ? playersC.map((v, i) => (
              <Player
                  key={i}
                  muted
                  playing
                  onError={(error) => handleError(error, i)}
                  onEnded={() => handleEnd(i)}
                  onProgress={(progress) => handleProgress(progress, i)}
                  playbackRate={15}
                  controls
                  url={_find(status, {playerId: i}).url}
              />
          )) : void 0}
        </div>

        <div className='d-flex w-100 flex-column align-items-center justify-content-center pt-2'>
          {started ? status.map((value, index) => (
                  <div className={started
                      ? 'd-flex flex-column align-items-center mb-4 pb-2 justify-content-center w-100'
                      : 'd-flex flex-column align-items-center mb-3 justify-content-center w-100'
                  }
                       key={index}>
                    <div className='input-group d-flex w-100'>
                      <code className="input-group-text text-primary">
                        {('000' + (index + 1)).slice(-4)}
                      </code>
                      <input disabled
                             className={
                               value.stat === 1 ? 'form-control is-valid' :
                                   value.stat === -1 ? 'form-control is-invalid' : 'form-control'
                             }
                             style={{flexGrow: 1}}
                             defaultValue={value.name}
                      />
                      <Copy text={value.name} className="btn btn-outline-primary bg-light copy">
                        <span>
                        <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 0 24 24"
                             width="18px" fill="#000000">
                          <path d="M0 0h24v24H0z" fill="none"/>
                          <path
                              d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"/>
                        </svg>
                        </span>
                      </Copy>
                    </div>
                    <div className='w-100' style={{marginTop: -4}}>
                      <div className='bg-light p-2 pt-3 w-100 d-flex'>
                        <div className='me-4'>
                          <strong>Progress:</strong> {value.played}%
                        </div>
                        <div className='me-4'>
                          <strong>Elapsed Running Time:</strong> {value.elapsed}s
                        </div>
                        <div className='me-4'>
                          <strong>Status:</strong> {value.message}
                        </div>
                        <div>
                          <strong>Downloaded:</strong> {value.loaded}%
                        </div>
                      </div>
                      <div className="progress" style={{height: 3}}>
                        <div className="progress-bar"
                             style={{width: value.played + '%'}}
                             role="progressbar"/>
                      </div>
                    </div>
                  </div>
              )) :
              <div className='w-100'>
              <textarea value={linksBulk} style={{maxWidth: 900}}
                        placeholder='URL'
                        className="form-control" rows="6"
                        onChange={data => setLinksBulk(data.target.value)}/>
                <div className='me-auto bg-light p-3 mb-4 position-relative rounded mt-3'
                     style={{minHeight: 158}}>
                  {files.length ? files.map((v, i) => (
                          <div key={v.name + i}>
                            <code className='me-3 text-body'>
                              <strong className='text-primary'>{i + 1}.</strong> {v.name}
                            </code>
                          </div>
                      ))
                      :
                      <span>Files</span>
                  }
                  <button style={{position: 'absolute', top: 4, right: 4}}
                          disabled={files.length === 0} className='btn btn-light btn-sm'
                          type="button"
                          onClick={() => {
                            setFiles([]);
                            fileInputRef.current.value = null;
                          }}>
                    Clear
                  </button>
                </div>
              </div>
          }
          <div className='pb-4 d-flex'>
            {started ?
                <button disabled={!started} className='btn btn-light me-4' type="button"
                        onClick={() => reset()}>
                  Restart
                </button> : void 0
            }
            {!started ?
                <div className='h-auto'>
                  <label style={{width: 120}} className='btn btn-light me-4 h-auto' htmlFor="files">
                    Choose Files
                  </label>
                </div> : void 0
            }
            <input type="file" multiple id='files' accept="video/mp4"
                   onChange={handleFiles} ref={fileInputRef}
                   className='d-none'/>
            {!started ?
                <div className='input-group h-100 position-relative'>
                  <button style={{width: 125}} className="btn btn-outline-secondary dropdown-toggle"
                          onClick={() => setDropOpen(!dropOpen)} type="button">
                    Players: {players}
                  </button>
                  <ul onClick={setDropOpen.bind(null, !dropOpen)}
                      className={dropOpen ? 'dropdown-menu d-block' : 'dropdown-menu'}
                      style={{minWidth: '5.7rem', top: 'calc(100% + 4px)'}}>
                    <li onClick={setPlayers.bind(null, 1)}>
                      <span className="dropdown-item">1</span></li>
                    <li onClick={setPlayers.bind(null, 2)}>
                      <span className="dropdown-item">2</span></li>
                    <li onClick={setPlayers.bind(null, 5)}>
                      <span className="dropdown-item">5</span></li>
                    <li onClick={setPlayers.bind(null, 10)}>
                      <span className="dropdown-item">10</span></li>
                    <li onClick={setPlayers.bind(null, 15)}>
                      <span className="dropdown-item">15</span></li>
                    <li onClick={setPlayers.bind(null, 25)}>
                      <span className="dropdown-item">25</span></li>
                    <li onClick={setPlayers.bind(null, 50)}>
                      <span className="dropdown-item">50</span></li>
                  </ul>
                  <button disabled={started} className='btn btn-primary' type="button"
                          onClick={() => start()}>
                    Start
                  </button>
                </div> : void 0
            }

          </div>
        </div>
      </div>
  );
}

export {Home};

function format(time) {
  let hrs = ~~(time / 3600);
  let mins = ~~((time % 3600) / 60);
  let secs = ~~time % 60;

  let ret = '';
  if (hrs > 0) {
    ret += '' + hrs + ':' + (mins < 10 ? '0' : '');
  }
  ret += '' + mins + ':' + (secs < 10 ? '0' : '');
  ret += '' + secs;
  return ret;
}
